import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
    SEARCH_BLAST,
    SEARCH_BLAST_SUCCESS,
    SEARCH_BLAST_FAILED,
    VIEW_BLAST,
    VIEW_BLAST_SUCCESS,
    VIEW_BLAST_FAILED,
    UPDATE_BLAST,
    UPDATE_BLAST_SUCCESS,
    UPDATE_BLAST_FAILED,
    CREATE_BLAST,
    CREATE_BLAST_SUCCESS,
    CREATE_BLAST_FAILED,
    DELETE_BLAST,
    DELETE_BLAST_SUCCESS,
    DELETE_BLAST_FAILED,
    RESET_STATUS,
} from 'constants/ActionTypes';
import {
    searchBlastApi,
    viewBlastDetailApi,
    viewBlastReceiversApi,
    updateBlastApi,
    createBlastApi,
    deleteBlastApi,
} from '../../appRedux/api/Blast';
import {
    legacyBlastSearchPayload,
    legacyBlastViewPayload,
    mapBlastListRow,
} from '../../appRedux/api/blastHelpers';
import {
    apiHandler,
    NOTIFICATION_INQUIRY_SUCCESS,
    NOTIFICATION_MUTATION_SUCCESS,
    NOTIFICATION_DELETE_SUCCESS,
} from './handler';

function* fetchAllBlastReceivers(payload) {
    const combined = [];
    let page = 0;
    const pageSize = 500;
    let lastPaging = null;

    while (true) {
        const { ok, data, message } = yield* apiHandler(viewBlastReceiversApi, {
            ...payload,
            page,
            pageSize,
        }, { successCodes: NOTIFICATION_INQUIRY_SUCCESS });

        if (!ok) {
            return { ok: false, message };
        }

        const rows = Array.isArray(data.body) ? data.body : [];
        combined.push(...rows);
        lastPaging = data.paging;

        const total =
            lastPaging && lastPaging.totalElements != null
                ? lastPaging.totalElements
                : combined.length;

        if (combined.length >= total || rows.length < pageSize) {
            break;
        }
        page += 1;
    }

    return { ok: true, rows: combined, paging: lastPaging };
}

function* fetchSearchBlast({ payload }) {
    if (payload != null) {
        const { ok, data, message } = yield* apiHandler(searchBlastApi, payload, {
            successCodes: NOTIFICATION_INQUIRY_SUCCESS,
        });

        if (ok) {
            yield put({
                type: SEARCH_BLAST_SUCCESS,
                payload: legacyBlastSearchPayload(data),
            });
        } else {
            yield put({ type: SEARCH_BLAST_FAILED, payload: message });
        }
    }
}

function* fetchViewBlast({ payload }) {
    if (payload != null) {
        const detailResult = yield* apiHandler(viewBlastDetailApi, payload, {
            successCodes: NOTIFICATION_INQUIRY_SUCCESS,
        });

        if (!detailResult.ok) {
            yield put({ type: VIEW_BLAST_FAILED, payload: detailResult.message });
            return;
        }

        const receiversResult = yield* fetchAllBlastReceivers(payload);

        if (!receiversResult.ok) {
            yield put({ type: VIEW_BLAST_FAILED, payload: receiversResult.message });
            return;
        }

        const legacy = legacyBlastViewPayload(
            detailResult.data.body,
            receiversResult.rows,
            receiversResult.paging,
        );
        yield put({ type: VIEW_BLAST_SUCCESS, payload: legacy });
    }
}

function* postEditBlast({ payload }) {
    if (payload != null) {
        yield put({ type: RESET_STATUS });

        const id =
            payload.id ||
            (payload.data && payload.data.messageBlastId) ||
            payload.messageBlastId;

        const { ok, data, message } = yield* apiHandler(
            updateBlastApi,
            { ...payload, id },
            { successCodes: ['INQ004', ...NOTIFICATION_MUTATION_SUCCESS] },
        );

        if (ok) {
            const body = data.body != null ? data.body : data.messageBlast;
            yield put({
                type: UPDATE_BLAST_SUCCESS,
                payload: mapBlastListRow(body),
            });
        } else {
            localStorage.setItem('Update Failed', message);
            yield put({ type: UPDATE_BLAST_FAILED, payload: message });
        }
    }
}

function* postInsertBlast({ payload }) {
    if (payload != null) {
        yield put({ type: RESET_STATUS });

        const { ok, data, message } = yield* apiHandler(createBlastApi, payload, {
            successCodes: ['INQ003', ...NOTIFICATION_MUTATION_SUCCESS],
        });

        if (ok) {
            yield put({ type: CREATE_BLAST_SUCCESS, payload: data });
        } else {
            localStorage.setItem('Create Failed', message);
            yield put({ type: CREATE_BLAST_FAILED, payload: message });
        }
    }
}

function* postDeleteBlast({ payload }) {
    if (payload != null) {
        const { ok, message } = yield* apiHandler(deleteBlastApi, payload, {
            successCodes: NOTIFICATION_DELETE_SUCCESS,
        });

        if (ok) {
            yield put({ type: DELETE_BLAST_SUCCESS, payload: null });
        } else {
            yield put({ type: DELETE_BLAST_FAILED, payload: message });
        }
    }
}

export function* searchBlast() {
    yield takeEvery(SEARCH_BLAST, fetchSearchBlast);
}

export function* viewBlast() {
    yield takeEvery(VIEW_BLAST, fetchViewBlast);
}

export function* editBlast() {
    yield takeEvery(UPDATE_BLAST, postEditBlast);
}

export function* createBlast() {
    yield takeEvery(CREATE_BLAST, postInsertBlast);
}

export function* removeBlast() {
    yield takeEvery(DELETE_BLAST, postDeleteBlast);
}

export default function* rootSaga() {
    yield all([
        fork(searchBlast),
        fork(viewBlast),
        fork(editBlast),
        fork(createBlast),
        fork(removeBlast),
    ]);
}
